import React, { useState, useEffect, useRef, memo } from 'react'
import Styled from 'styled-components'
import PropTypes from 'prop-types'
import { useSelector, useDispatch } from 'react-redux'
import { SET_FILTER_OPTION_ALL } from 'estimate_list/reducers/initial'

const FilterColumn = ({ children, title, optionAll, filterCategory, pricelength }) => {
    const setSearchDataOption = useSelector(state => state.initial.setSearchDataOption)
    const filterOptionAll = useSelector(state => state.initial.filterOptionAll)
    const selectCategory = useSelector(state => state.initial.selectCategory)
    const [allView, setAllView] = useState(filterCategory ? true : false)
    const [innerHeight, setInnerHeight] = useState('')
    const [isTitleList, setIsTitleList] = useState(false)

    const column = useRef(null)
    const basicColumnHeight = 42

    const dispatch = useDispatch()

    useEffect(() => {
        column.current.childNodes.forEach(row => {
            if (row.className === 'row') {
                row.childNodes.forEach(cell => {
                    if (cell.className === 'cell') {
                        return setInnerHeight(cell.offsetHeight)
                    }
                    if (cell.className === 'title_list') {
                        return setIsTitleList(true)
                    }
                })
            }
        })
    })

    useEffect(() => {
        if (optionAll) {
            setAllView(filterOptionAll)
        }
    }, [filterOptionAll]) // eslint-disable-line

    useEffect(() => {
        // dispatch({
        //     type: SET_FILTER_OPTION_ALL,
        //     data: false
        // })
        setAllView(false)
    }, [selectCategory]);


    const onClickAllView = () => {
        if (optionAll) {
            dispatch({
                type: SET_FILTER_OPTION_ALL,
                data: !allView
            })
        } else {
            setAllView(state => !state)
        }
    }


    return (
        <Column className={`${allView ? 'active' : ''}`} ref={column} optionAll>
            <div className="title">
                {title}
                {/*임시 처리 영역 '가격'일 경우 + 버튼 비노출*/}
                {(isTitleList ||
                    filterCategory ||
                    basicColumnHeight < innerHeight ||
                    (optionAll && setSearchDataOption.specList.length > 4) || pricelength  > 3)   &&
                    (
                        <button className="btn_extend" onClick={onClickAllView}>
                        더보기 <i className="icon" /></button>
                    )}
            </div>
            {children}
        </Column>
    )
}

FilterColumn.propTypes = {
    children: PropTypes.element,
    title: PropTypes.string.isRequired,
}

FilterColumn.defaultProps = {
    optionAll: false // 옵션 전체보기 칼럼인지
}

const Column = Styled.div`
    position: relative;
    clear: both;
    padding-left: 180px;

    & + & {
        border-top: 1px solid #c8c8c8
    }
    button {
        font-size: 12px;
    }
    .title {
        position: absolute;
        top: 0px;
        bottom: 0px;
        left: 0px;
        width: 180px;
        background-color: #244e83;
        font-size: 13px;
        font-weight: 700;
        line-height: 39px;
        color: #fff;
        padding-left: 20px;
    }
    .btn_extend {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        overflow: hidden;
        color: transparent;
        display: block;
        width: 100%;

        &:before,
        &:after {
            position: absolute;
            background: #fff;
            display: inline-block;
            vertical-align: top;
            content: "";
        }
        &:before {
            top: 18px;
            right: 15px;
            width: 10px;
            height: 2px;
        }
        &:after {
            top: 14px;
            right: 19px;
            width: 2px;
            height: 10px;
        }
    }
    .row {
        position: relative;
        overflow: hidden;
        clear: both;
        height: 41px;
    }
    .title_list,
    .list {
        position: relative;
        overflow: hidden;

        li {
            position: relative;
            float: left;
            padding: 9px 10px 8px;

            a, button {
                position: relative;
                display: inline-block;
                height: 24px;
                line-height: 24px;
                padding: 0 5px;
                color: #202022;
                vertical-align: top;

                .text {
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    display: inline-block;
                    vertical-align: top;
                }
                .num {
                    display: none;
                    padding-left: 2px;
                    font-size: 11px;
                    color: #999;
                }
                i {
                    display: none
                }
            }
            &.active {
                button {
                    position: relative;
                    background-color: #418ded;
                    color: #fff;

                    .num {
                        color: #fff
                    }

                    &:hover i {
                        position: absolute;
                        top: -6px;
                        right: -8px;
                        width: 14px;
                        height: 14px;
                        background: #f2f2f2;
                        box-shadow: 0px 1px 1px #0000004D;
                        border-radius: 7px;
                        color: #418ded;
                        display: block;
                        font-size: 10px;
                        text-align: center;
                        line-height: 14px;
                    }
                }
            }
        }
    }
    .title_list {
        height: 41px;
        padding: 0 0 0 11px;
    }
    .cell {
        overflow-y: hidden;
        max-height: 330px;
    }
    .cell_title {
        display: none;
        height: 42px;
        color: #333;
        line-height: 42px;
        margin-left: 26px;
        border-bottom: 1px solid #c8c8c8;
        font-size: 13px;
        font-weight: 700;

        button {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            display: inline-block;
            height: 42px;
            line-height: 42px;
            color: #181818;
            font-weight: 700;

            .num {
                padding-left: 4px;
                font-size: 11px;
                font-weight: 400;
                color: #999;
            }
        }
    }
    .cell_title_cate {
        cursor: default;

        .num {
            padding-left: 4px;
            font-size: 11px;
            font-weight: 400;
            color: #999;
        }
        button {
            cursor: default;
        }
        a {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            display: inline-block;
            height: 42px;
            line-height: 42px;
            color: #181818;
            font-weight: 700;
            vertical-align: top;
            font-size: 12px;
        }
        a:hover {
            color: #418ded
        }
    }
    .list {
        max-height: none;
        padding: 5px 0 5px 11px;

        li {
            padding: 4px 10px;
        }
    }
    .title_sort {
        display: none;
        overflow: hidden;
        margin-left: 26px;
        border-bottom: 1px solid #c8c8c8;
    }
    .sort_btn {
        display: block;
        float: left;
        width: 83px;
        height: 40px;
        font-size: 13px;
        line-height: 40px;
        color: #666;
        text-align: left;

        i {
            display: none
        }

        &.active {
            color: #333;
            font-weight: 700;

            i {
                top: 1px;
                display: inline-block;
                font-size: 11px;
                transform: scale(0.6);
                color: #418ded;
                margin: 0 4px 0 0;
            }
        }
    }
    .etc_price {
        .title_list {
            display: inline-block;
            max-width: 420px;
            max-height: 41px;
            vertical-align: top;
            background: none;
            border: 0;
        }
        .range {
            float: right;
            margin: 0 22px 0 0;
            display: inline-block;
            overflow: hidden;
            padding: 8px 0 6px 17px;
            line-height: 25px;
            vertical-align: top;
        }
        .range_txt {
            display: inline-block;
            margin: 0 7px 0 0;
            color: #999;
            vertical-align: top;
        }
        .range_input {
            display: inline-block;
            width: 100px;
            height: 25px;
            border: 1px solid #c8c8c8;
            background-color: #fff;
            color: #999;
            vertical-align: top;

            input {
                width: 94px;
                height: 23px;
                border: 0;
                line-height: 18px;
                color: #202022;
                text-align: right;
                vertical-align: top;
            }
        }
        .range_at {
            display: inline-block;
            margin: 2px 3px 0;
            color: #999;
            font-size: 15px;
            vertical-align: top;
        }
        .price_search {
            position:relative;
            width: 25px;
            height: 25px;
            overflow: hidden;
            white-space: nowrap;
            text-indent: 100%;
            display: inline-block;
            vertical-align: top;

            i {
                position: absolute;
                left: 6px;
                top: 6px;
                text-indent: 0;
                color: #c5c5c5;
                font-size: 14px;
            }
        }
    }
    &.active {
        background-color: ${props => !props.optionAll ? '#f7f7fa' : '#fff'};

        .row {
            height: auto;
        }
        .btn_extend {
            &:after {
                content: none
            }
        }
        .title {
            background: #204676;
        }
        .title_list {
            background: #efeff3
        }
        .list {
            li {
                width: 183px;

                .text {
                    max-width: 167px; /* li width - 16 */
                }
                .num {
                    display: inline-block;
                }
            }
        }
        .cell {
            overflow-y : auto
        }
        .cell_title {
            display: block
        }
        .etc_price {
            background-color: #efeff3;
        }
        .title_sort {
            display: block
        }
    }
`

export default memo(FilterColumn)



// WEBPACK FOOTER //
// ./src/estimate_list/components/filter/filter_column.js